// removed by extract-text-webpack-plugin
module.exports = {"app":"NghkZ4oYFr3noleiCV5cu","main":"_2W1wrPw1MEr4v1TqOhwpyf","nav":"_20_olkP9L6RmSnxl8nYr25"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 209
// module chunks = 0